var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-bform-group',_vm._b({attrs:{"label":_vm.name}},'nx-bform-group',_vm.$attrs,false),[_vm._t("default",function(){return [_c('nx-bform-input',{attrs:{"name":_vm.name,"value":_vm.$attrs.value},on:{"input":_vm.$listeners.input}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }